// environment.ts

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBnJvV8BcHAVSay-VPSJBd-1lbKonFmq3c",
    authDomain: "angular-form-ff50d.firebaseapp.com",
    databaseURL: "https://angular-form-ff50d-default-rtdb.firebaseio.com",
    projectId: "angular-form-ff50d",
    storageBucket: "angular-form-ff50d.appspot.com",
    messagingSenderId: "210439358147",
    appId: "1:210439358147:web:fd5086f68756c257c88476",
  }
};